import { render, staticRenderFns } from "./MigradorVentas.vue?vue&type=template&id=74dcb58a&scoped=true"
import script from "./MigradorVentas.vue?vue&type=script&lang=js"
export * from "./MigradorVentas.vue?vue&type=script&lang=js"
import style0 from "./MigradorVentas.vue?vue&type=style&index=0&id=74dcb58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dcb58a",
  null
  
)

export default component.exports